(() => {
  const initialized = new WeakSet();

  function enhance(root) {
    if (initialized.has(root) || root.dataset.confirmationEnhanced === 'true' || !root.dataset.confirmationTitle) return;
    const form = document.getElementById(root.dataset.formId);
    const email = root.querySelector('input[name="contact[email]"]');
    const status = root.querySelector('.mgp-restock__status[role="status"]');
    const header = root.querySelector('.mgp-restock__header');
    if (!form || !email || !status || !header) return;
    initialized.add(root);
    root.dataset.confirmationEnhanced = 'true';

    const copy = (key) => root.dataset['confirmation' + key];
    const node = (tag, className, text) => {
      const element = document.createElement(tag);
      element.className = className;
      element.textContent = text || '';
      return element;
    };
    const hint = node('p', 'mgp-restock__confirmation-hint', copy('Hint'));
    header.after(hint);
    const consent = root.querySelector('.mgp-restock__consent');
    const consentText = consent?.querySelector('span');
    if (copy('Consent') && consentText) {
      consentText.textContent = copy('Consent');
      root.dataset.confirmationCompact = 'true';
    }

    const panel = node('div', 'mgp-restock__confirmation-panel');
    panel.hidden = true;
    panel.tabIndex = -1;
    panel.setAttribute('role', 'status');
    panel.setAttribute('aria-live', 'polite');
    panel.setAttribute('aria-atomic', 'true');
    panel.append(
      node('h3', 'mgp-restock__confirmation-title', copy('Title')),
      node('p', 'mgp-restock__confirmation-pending', copy('Pending'))
    );
    const address = node('strong', 'mgp-restock__confirmation-email');
    const edit = node('button', 'mgp-restock__confirmation-edit', copy('Edit'));
    edit.type = 'button';
    const resend = node('button', 'mgp-restock__confirmation-edit', copy('Resend'));
    resend.type = 'button';
    resend.hidden = !copy('Resend') || !copy('Wait');
    const actions = node('div', 'mgp-restock__confirmation-actions');
    actions.append(resend, edit);
    panel.append(
      address,
      node('p', 'mgp-restock__confirmation-instructions', copy('Instructions')),
      node('p', 'mgp-restock__confirmation-spam', copy('Spam')),
      actions
    );
    root.append(panel);

    let submission = null;
    let selectedVariant = root.dataset.selectedVariant;
    let resendAt = 0;
    let countdown = null;

    function updateCountdown() {
      if (!root.isConnected) {
        clearInterval(countdown);
        return;
      }
      const minutes = Math.max(0, Math.ceil((resendAt - Date.now()) / 60000));
      resend.disabled = minutes > 0;
      resend.textContent = minutes > 0 ? copy('Wait')?.replace('{minutes}', String(minutes)) : copy('Resend');
      if (!minutes) clearInterval(countdown);
    }

    function reset() {
      submission = null;
      clearInterval(countdown);
      delete root.dataset.confirmationState;
      panel.hidden = true;
      address.textContent = '';
    }

    edit.addEventListener('click', () => {
      reset();
      status.textContent = '';
      delete status.dataset.error;
      email.focus();
      email.select();
    });

    resend.addEventListener('click', () => {
      if (resend.disabled || Date.now() < resendAt || !submission || root.hidden ||
          root.getAttribute('aria-busy') === 'true' || submission.variant !== root.dataset.selectedVariant) return;
      const submittedEmail = submission.email;
      reset();
      email.value = submittedEmail;
      form.requestSubmit();
    });

    form.addEventListener('submit', (event) => {
      if (root.dataset.confirmationState === 'pending') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (root.hidden || root.getAttribute('aria-busy') === 'true' || !form.checkValidity()) return;
      submission = {
        email: email.value.trim(),
        variant: root.dataset.selectedVariant
      };
    }, true);

    const observer = new MutationObserver(() => {
      if (selectedVariant !== root.dataset.selectedVariant) {
        selectedVariant = root.dataset.selectedVariant;
        reset();
        return;
      }
      if (!submission || root.hidden || submission.variant !== root.dataset.selectedVariant) return;
      if (status.dataset.error === 'true' || status.textContent.trim() !== root.dataset.success?.trim()) return;
      if (root.dataset.confirmationState === 'pending') return;
      const moveFocus = root.contains(document.activeElement);
      address.textContent = submission.email;
      resendAt = Date.now() + 20 * 60 * 1000;
      clearInterval(countdown);
      updateCountdown();
      countdown = setInterval(updateCountdown, 30000);
      panel.hidden = false;
      root.dataset.confirmationState = 'pending';
      if (moveFocus) panel.focus({ preventScroll: true });
    });
    observer.observe(status, { childList: true, characterData: true, subtree: true });
    observer.observe(root, { attributes: true, attributeFilter: ['data-selected-variant'] });
  }

  function scan(scope = document) {
    if (scope.matches?.('restock-alert')) enhance(scope);
    scope.querySelectorAll?.('restock-alert').forEach(enhance);
  }

  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
